var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkill(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12.917,
    height: 14.172,
    viewBox: "0 0 12.917 14.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5.696 -4.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.393,5.8V5.09a.59.59,0,1,0-1.181,0v.794a1.184,1.184,0,0,0,0,1.956V18.081a.59.59,0,1,0,1.181,0V7.925a1.182,1.182,0,0,0,0-2.126Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.043,12.948V5.09a.59.59,0,1,0-1.181,0V12.9a1.183,1.183,0,0,0,0,2.089v3.089a.59.59,0,1,0,1.181,0V14.948a1.18,1.18,0,0,0,0-2Z",
    transform: "translate(-3.107)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.826,8.165V5.09a.59.59,0,1,0-1.181,0V8.165a1.18,1.18,0,0,0,0,2.045v7.872a.59.59,0,1,0,1.181,0V10.209a1.18,1.18,0,0,0,0-2.045Z",
    transform: "translate(-6.347)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.167,16.273a1.177,1.177,0,0,0-.59-1.022V5.09a.59.59,0,0,0-1.181,0v10.16a1.18,1.18,0,0,0,0,2.045v.786a.59.59,0,1,0,1.181,0v-.786a1.177,1.177,0,0,0,.59-1.022Z",
    transform: "translate(-9.554)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkill);
export default __webpack_public_path__ + "static/media/skill.6bfe205b21dcef745bd616e55102c75b.svg";
export { ForwardRef as ReactComponent };